
import { Vue, Component, Prop } from 'vue-property-decorator';
import { QuestionData } from '../types';
import ProductList from '@/components/ProductList.vue';

@Component({
	components: {
		ProductList
	}
})
export default class Question extends Vue {
	@Prop() data!: QuestionData;
	@Prop() canFinish!: boolean;

	private finishRegistration(): void {
		this.$emit('finish');
	}
}
